import React from 'react';
import Banner from '../../components/Banner/Banner';


const About = () => {
    return (
        <div className="iot-container">
          <Banner/>
          <h1 className="iot-title">Καλωσήρθατε στο IoT Μέγαρα</h1>
          <p>
            
            Το ΙοΤ Μέγαρα είναι η πλατφόρμα τηλεδιαχείρισης του οδοφωτισμού του Δήμου Μεγάρων.
            Στην πλατφόρμα αυτή περιλαμβάνονται οι παρακάτω λειτουργίες:
          </p>
    
          <ul className="iot-list">
            <li>Τηλεδιαχείριση Οδοφωτισμού</li>
            <li>Διαχείριση Συσκευών</li>
            <li>Μελέτη Ραδιοκάλυψης</li>
            <li>Χρονοπρογραμματισμός</li>
          </ul>
    
          <section>
            <div className="iot-section-header">
                <h2 className="iot-section-title">Τηλεδιαχείριση Οδοφωτισμού</h2>
            </div>
            <p>
              Στην ενότητα της Τηλεδιαχείρισης ο χρήστης μπορεί να στείλει εντολές στα φωτιστικά να ανάψουν, να σβήσουν αλλά και να διαβαθμιστούν (Dimming)
              σε μία ποσοστιαία κλίμακα από 0 έως 100%. Η ενότητα αυτή περιλαμβάνει τη τηλεδιαχείριση των φωτιστικών μέσω διαδραστικού χάρτη που αποτυπώνεται
              η θέση του κάθε φωτιστικού. Στον χάρτη αυτό μπορεί να γίνει πολλαπλή επιλογή φωτιστικών χρησιμοποιώντας πολύγωνα επιλογής πάνω στον χάρτη.
              Οι εντολές μπορούν να αποστέλλονται είτε σε όλες τις συσκευές, είτε μόνο σε επιλεγμένες αλλά και μεμονωμένα και ανεξάρτητα σε κάθε φωτιστικό.
              Οι επιπρόσθετες ρυθμίσεις λειτουργιών περιλαμβάνουν τον προκαθορισμό λειτουργίας κατά τη δύση και ανατολή του ηλίου αλλά και χρονοπρογραμματισμό.
              Σε κάθε συσκευή που απεικονίζεται στο διαδραστικό χάρτη περιλαμβάνονται πληροφορίες σχετικά με τη λειτουργία και εξοικονόμηση ενέργειας.
            </p>
          </section>
    
          <section>
            <div className="iot-section-header">
                <h2 className="iot-section-title">Διαχείριση Συσκευών</h2>
            </div>
            <p>
              Σε αυτή την ενότητα ο χρήστης μπορεί προσθέσει και να τροποποιήσει πληροφορίες των συσκευών. Οι συσκευές απεικονίζονται και σε αυτή την ενότητα,
              σε διαδραστικό χάρτη όπου επιλέγοντας το κάθε σημείο μπορεί ο χρήστης να προσθέσει νέα συσκευή είτε αυτή είναι controller, είτε gateway.
              Επιλέγοντας σε δεύτερο χρόνο κάποια πινέζα στο χάρτη μπορεί να τροποποιήσει και να αποθηκεύσει εκ νέου τα στοιχεία της αλλά και να σείρει την πινέζα σε κάποια άλλη θέση.
              Εδώ περιλαμβάνεται και ένας πίνακας που περιλαμβάνει μαζικά όλες τις συσκευές.
            </p>
          </section>
    
          <section>
            <div className="iot-section-header">
                <h2 className="iot-section-title">Μελέτη Ραδιοκάλυψης</h2>
            </div>
            <p>
              Η ενότητα αυτή περιλαμβάνει τις μελέτες που μπορεί να πραγματοποιηθούν απομακρυσμένα για την ορθή τοποθέτηση ενός gateway προκειμένου να επικοινωνεί με τη κάθε συσκευή.
              Η θέση που θα τοποθετηθεί το gateway είναι μείζονος σημασίας και αν δεν γίνει σωστά μπορεί να δημιουργήσει προβλήματα ραδιοκάλυψης με αποτέλεσμα το φωτιστικό να μην ανταποκρίνεται στις εντολές.
            </p>
            <p>
              Για τη σωστή μελέτη χρησιμοποιούνται δύο διαδραστικοί χάρτες. Ο ένας χρησιμεύει για την τοποθέτηση του gateway και των πιθανών θέσεων.
              Όταν το gateway τοποθετείται στο χάρτη στη πιθανή θέση, ξεκινάει η αποστολή εντολών προς προκαθορισμένο φωτιστικό το οποίο μεταφέρεται πάνω στον χάρτη.
              Ο δεύτερος χάρτης είναι τριών διαστάσεων και απεικονίζει ξεκάθαρα τις θέσεις της μελέτης σε σχέση με την γεωγραφική κατανομή του εδάφους.
            </p>
          </section>
    
          <section>
          <div className="iot-section-header">
                <h2 className="iot-section-title">Επιπρόσθετες λειτουργίες</h2>
            </div>
            
            <p>
              Η πλατφόρμα περιλαμβάνει:
            </p>
            <ul className="iot-list">
              <li>Στατιστικά στοιχεία</li>
              <li>Αποστολή εντολών σε πραγματικό χρόνο</li>
              <li>Απεικόνιση 3D χάρτη ραδιοκάλυψης με φάσμα 1,8 χιλιομέτρων</li>
              <li>Προκαθορισμένες ρυθμίσεις συσκευών</li>
              <li>Παρακολούθηση εισερχομένων και εξερχομένων εντολών/μηνυμάτων</li>
              <li>Τηλεδιαχείριση μέσω φωνητικών εντολών</li>
              <li>Mobile responsive περιβάλλον</li>
            </ul>
          </section>
        </div>
      );
    };
    

export default About;